import React, { useState, useMemo } from 'react';
import { Row, Col, Button, Spinner, Badge, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faShieldAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { getInitials } from '../utils/helpers';

const UsersList = ({ users, isLoading, onSelectUser }) => {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const s = search.toLowerCase();
    return users.filter(u =>
      !u.head_office && (
        (`${u.first_name}${u.last_name ? ` ${u.last_name}` : ''}` || u.email || '').toLowerCase().includes(s) ||
        (u.email || '').toLowerCase().includes(s)
      )
    );
  }, [users, search]);

  if (isLoading) {
    return (
      <div className="auth-loading">
        <Spinner animation="border" style={{ color: '#3f88a5' }} />
        <p>Loading users...</p>
      </div>
    );
  }

  return (
    <div className="users-list-tab">
      <div className="auth-tab-header">
        <div>
          <h4>Users</h4>
          <p className="text-muted mb-0">{users.length} total users</p>
        </div>
      </div>

      <div className="auth-search-bar">
        <FontAwesomeIcon icon={faSearch} className="search-icon" />
        <Form.Control
          type="text"
          placeholder="Search users by name or email..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="auth-search-input"
        />
      </div>

      <div className="users-grid">
        {filtered.map(user => (
          <div key={user.id} className="user-card">
            <div className="user-card-left">
              <div className="user-avatar">
                {getInitials(`${user.first_name}${user.last_name ? ` ${user.last_name}` : ''}` || user.email)}
              </div>
              <div className="user-info">
                <div className="user-name">{`${user.first_name}${user.last_name ? ` ${user.last_name}` : ''}` || 'Unknown'}</div>
                <div className="user-email">{user.email}</div>

              </div>
            </div>
            <Button
              className="auth-btn-manage"
              onClick={() => onSelectUser(user)}
            >
              <FontAwesomeIcon icon={faShieldAlt} className="me-2" />
              Manage Permissions
            </Button>
          </div>
        ))}

        {filtered.length === 0 && (
          <div className="auth-empty">
            <FontAwesomeIcon icon={faUser} className="auth-empty-icon" />
            <p>No users found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UsersList;